import React from 'react';
import AppSidebar from './sidebar/AppSidebar';

import useStyles from './styles/baseLayoutStyles';
import { TopNavContainer, TopNavigator } from './TopNavigator';
import clsx from 'clsx';
import Head from 'next/head';
import { Slide, useScrollTrigger } from '@material-ui/core';
import Footer from './Footer';
import { BaseLayoutProvider } from './BaseLayoutProvider';
import AppmodelSidebarProvider, {
    BaseLayoutDataType
} from 'src/components-pages/shared/appmodel.provider';

export interface BaseModelProps {
    baseData: BaseLayoutDataType;
}

interface Props extends BaseModelProps {
    children: React.ReactNode;
    variant?: AppBackVariant;
    navVariant?: AppBackVariant;
    classes?: { root?: string; mainContainer?: string };
    disableButtons?: boolean;
    hasFooter?: boolean;
    window?: any;
    disableTopHide?: boolean;
    autoHeight?: boolean;
}

function HideOnScroll({
    children,
    window
}: {
    children: Props['children'];
    window: Props['window'];
}) {
    const trigger = useScrollTrigger({ target: window ? window : undefined });

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children as any}
        </Slide>
    );
}

const BaseLayout = ({
    children,
    window,
    disableButtons,
    classes,
    variant = 'dark',
    navVariant = 'monolite',
    hasFooter = false,
    disableTopHide = false,
    autoHeight = false,
    baseData
}: Props) => {
    const layoutClasses = useStyles();

    return (
        <AppmodelSidebarProvider data={baseData}>
            <BaseLayoutProvider>
                <Head>
                    <link rel="icon" href="/favicon.ico" />
                </Head>
                <div className={classes?.root}>
                    <div
                        className={clsx(layoutClasses.root, {
                            [layoutClasses.rootMinHeight]: !autoHeight,
                            [layoutClasses.blackBackground]: variant === 'black',
                            [layoutClasses.darkBackground]: variant === 'dark',
                            [layoutClasses.monoliteBackground]: variant === 'monolite',
                            [layoutClasses.lightBackground]: variant === 'light'
                        })}>
                        {disableTopHide ? (
                            <TopNavContainer navVariant={navVariant}>
                                <TopNavigator disableButtons={disableButtons} />
                            </TopNavContainer>
                        ) : (
                            <HideOnScroll window={window}>
                                <TopNavContainer navVariant={navVariant}>
                                    <TopNavigator disableButtons={disableButtons} />
                                </TopNavContainer>
                            </HideOnScroll>
                        )}
                        <AppSidebar />
                        <div className={clsx(layoutClasses.mainContainer, classes?.mainContainer)}>
                            {children}
                        </div>
                    </div>
                    {hasFooter && <Footer variant={variant} />}
                </div>
            </BaseLayoutProvider>
        </AppmodelSidebarProvider>
    );
};

export default BaseLayout;
